import loadable from '@loadable/component'

export default [
  {
    path: '/game/GreedyHiya',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-GreedyHiya" */ '~/pages/game/GreedyHiya'
        )
    ),
  },
  {
    path: '/gameRoom/GreedyHiya',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-gameRoom-GreedyHiya" */ '~/pages/game/gameRoom/GreedyHiya'
        )
    ),
  },
  {
    path: '/gameRoom/GreedyHiya/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-gameRoom-GreedyHiya-Record" */ '~/pages/game/gameRoom/GreedyHiya/Record'
        )
    ),
  },
  {
    path: '/gameRoom/GreedyHiya/roundRecord',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-gameRoom-GreedyHiya-roundRecord" */ '~/pages/game/gameRoom/GreedyHiya/RoundRecord'
        )
    ),
  },
  {
    path: '/gameRoom/GreedyHiya/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-gameRoom-GreedyHiya-Rules" */ '~/pages/game/gameRoom/GreedyHiya/Rules'
        )
    ),
  },
  {
    path: '/game/GreedyHiya/banner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-GreedyHiya-banner" */ '~/pages/game/GreedyHiya/Activity/Fomo/Banner'
        )
    ),
  },
]
